export default function createCustomEvent(eventName, bubbles: boolean = true, cancelable: boolean = true) {
	var event;
	if (typeof (Event) === 'function') {
		event = new Event(eventName, {
			bubbles: bubbles,
			cancelable: cancelable
		});
	} else {
		event = document.createEvent('Event');
		event.initEvent(eventName, bubbles, cancelable);
	}
	return event;
}